<div *ngIf="loading">
    <!-- Loader template or spinner -->
    <div class="loader-span"></div>
</div>

<div class="contents">
    <div class="modal-header">
        <h3 class="modal-title" id="spocPhoneUpdateModalLabel">Update SPOC Phone Number</h3>
    </div>
    <div class="modal-body">
        <form [formGroup]="spocPhoneForm" (ngSubmit)="spocPhoneSubmit(spocPhoneForm.value)" id="spocPhoneUpdateForm">
            <div class="row">
                <div class="col-12 pb-3">
                    <div
                        [class.err-input]="spocPhoneForm.controls['mobileNumber'].invalid && (spocPhoneForm.controls['mobileNumber'].dirty || spocPhoneForm.controls['mobileNumber'].touched)">
                        <label for="mobileNumber">Phone Number</label>
                        <div class="input-count">
                            <ng-select [items]="countryList" bindLabel="dial_code"
                                bindValue="dial_code" formControlName="countryCode" [searchFn]="customSearchFn"
                                [placeholder]="'Select'" [disabled]="true">
                                <ng-template ng-option-tmp let-item="item">
                                    {{item.dial_code}} <br>
                                    <small>{{item.name}}</small>
                                </ng-template>
                            </ng-select>
                            <input class="form-control" type="text" name="mobileNumber"
                                formControlName="mobileNumber" (keypress)="onlyAllowNumbers($event, phoneMaxLength)"
                                [minLength]="phoneMinLength" [maxLength]="phoneMaxLength" (paste)="onPaste($event)"
                                placeholder="Enter Phone Number">
                        </div>
                    </div>
                    <div
                        *ngIf="spocPhoneForm.controls['mobileNumber'].invalid && (spocPhoneForm.controls['mobileNumber'].dirty || spocPhoneForm.controls['mobileNumber'].touched)">
                        <div *ngIf="spocPhoneForm.controls['mobileNumber'].errors?.required">
                            <span class="error sum">Phone Number is required.</span>
                        </div>
                        <div *ngIf="spocPhoneForm.controls['mobileNumber'].errors?.cannotStartWithZero">
                            <span class="error sum">Phone Number cannot start with 0.</span>
                        </div>
                        <div *ngIf="spocPhoneForm.controls['mobileNumber'].errors?.invalidPhone">
                            <span class="error sum">{{ phoneErrorMessage }}</span>
                        </div>
                    </div>
                    <div
                        *ngIf="spocPhoneForm.controls['countryCode'].invalid && (spocPhoneForm.controls['countryCode'].dirty || spocPhoneForm.controls['countryCode'].touched)">
                        <span class="error sum">Country code is required.</span>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <footer class="modal-footer">
        <button type="button" class="btn btn-cancel" (click)="modal.dismissAll()">Cancel</button>
        <button type="submit" class="btn btn-save" form="spocPhoneUpdateForm"
            [disabled]="spocPhoneForm.get('mobileNumber')?.invalid || loading || !hasFormChanged()">Update</button>
    </footer>
</div>
